module.exports = __webpack_public_path__ + "static/media/bg-header.2c5f6317.png";